module.exports = __webpack_public_path__ + "img/undraw_teaching_re_g7e3.73e5be70.svg";